import { z } from "zod";
import { schemes } from "@zeal/common";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { IGetEmployeeCheckObject } from "../getEmployeeCheck/getEmployeeCheck.jsonschema";

export const CheckCorrectionStatuses = [
  "draft",
  "applied",
  "cancelled",
] as const;

export type TCheckCorrectionStatus = (typeof CheckCorrectionStatuses)[number];

export interface ICheckCorrection {
  readonly correctionID: string;
  readonly companyID: string;
  readonly checkID: string;
  readonly testMode: boolean;
  readonly status: TCheckCorrectionStatus;
  readonly user_email: string;
  readonly employee_check: {
    readonly original: IGetEmployeeCheckObject;
    readonly modified: IGetEmployeeCheckObject;
  };
  readonly transactions: string[];
  readonly createdAt: string;
  readonly updatedAt: string;
}

export const createCheckCorrectionRequestSchema = z.object({
  employeeCheckID: schemes.uuid(),
  test: z.boolean().optional(),
});

export type TCreateCheckCorrectionRequest = z.infer<
  typeof createCheckCorrectionRequestSchema
>;

export type TCreateCheckCorrectionResponse = IApiResponse<ICheckCorrection>;

export const getCheckCorrectionRequestSchema = z.object({
  correctionID: schemes.uuid(),
  test: z.boolean().optional(),
});

export type TGetCheckCorrectionRequest = z.infer<
  typeof getCheckCorrectionRequestSchema
>;

export type TGetCheckCorrectionResponse = IApiResponse<ICheckCorrection>;

export const patchCheckCorrectionRequestSchema = z.object({
  correctionID: schemes.uuid(),
  modified: z.any().optional(),
  status: z.enum(CheckCorrectionStatuses).optional(),
  test: z.boolean().optional(),
});

export type TPatchCheckCorrectionRequest = z.infer<
  typeof patchCheckCorrectionRequestSchema
>;

export type TPatchCheckCorrectionResponse = IApiResponse<ICheckCorrection>;
